import {
  Dialog,
  DialogProps,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { themePalette } from '@theme/muiTheme';
import { CloseIcon } from '@utils/iconsDefs';
import { FC } from 'react';

export type CustomDialogProps = Omit<DialogProps, 'onClose'> & {
  title?: string;
  onClose?: () => void;
  hideClose?: boolean;
};

export const CustomDialog: FC<CustomDialogProps> = ({
  title,
  children,
  hideClose = false,
  ...props
}) => {
  return (
    <Dialog {...props}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p="24px 24px 12px"
      >
        <Typography variant="h2">{title}</Typography>

        {!hideClose && (
          <IconButton onClick={props.onClose} size="small" sx={{ p: 1 }}>
            <CloseIcon fill={themePalette.grey[900]} width={14} height={14} />
          </IconButton>
        )}
      </Stack>

      {children}
    </Dialog>
  );
};
